export default function newsResult() {
    return {
        scope: {
            result: '=',
            showSummary: '@'
        },
        replace: true,
        restrict: 'EA',
        template: `
            <li> 
                <div class="card news-card" style="max-width:100%">         
                    <a ng-href="{{ ::result.url }}" class="card-link news-card-image card-image-link">
                        <div class="lazywrap" aspect="square" ng-if="result.imageUrl">
                            <img data-src="{{ ::result.imageUrl }}" class="lazyload" alt="{{ ::result.name }}" />    
                        </div>
                    </a>
                    <div class="news-card-body card-body">
                        <a ng-href="{{ ::result.url }}" class="card-link">
                            <h5 ng-bind="::result.name" class="card-title"></h5>
                        </a>

                        <div class="card-text" ng-if="showSummary">
                            <p ng-bind="::result.description"></p>
                        </div>
                    </div>
                </div>
            </li>`
    };
}